import { hasPermission, permission } from "./permission";
import { route } from "./route";

export type AppModuleActionProps = {
  label: string;
  href: string;
  // The list the action opens; the dashboard starts it at page 1 again (its filters stay).
  listKey: string;
  permission: string;
};

export type AppModuleProps = {
  title: string;
  description: string;
  href: string;
  // The list `href` opens; the dashboard starts it at page 1 again (its filters stay).
  listKey: string;
  icon: string;
  permission: string;
  superAdminOnly?: boolean;
  // A tile with actions shows a button per action the user may open, instead of opening href.
  actions?: AppModuleActionProps[];
};

export const dailyUsageModules: AppModuleProps[] = [
  {
    title: "મટીરીયલ",
    description: "મટીરીયલ ઓર્ડર અને ખરીદી મેનેજ કરો",
    href: route.materialOrders,
    listKey: "materialOrders",
    icon: "🚚",
    permission: permission.materialOrdersMenu,
    actions: [
      {
        label: "ઓર્ડર",
        href: route.materialOrders,
        listKey: "materialOrders",
        permission: permission.materialOrdersMenu,
      },
      {
        label: "ખરીદી",
        href: route.materialPurchases,
        listKey: "materialPurchases",
        permission: permission.materialPurchasesMenu,
      },
    ],
  },
  {
    title: "કટીંગ",
    description: "કટીંગ ઓર્ડર અને રિસીવ મેનેજ કરો",
    href: route.cuttingOrders,
    listKey: "cuttingOrders",
    icon: "✂️",
    permission: permission.cuttingOrdersMenu,
    actions: [
      {
        label: "ઓર્ડર",
        href: route.cuttingOrders,
        listKey: "cuttingOrders",
        permission: permission.cuttingOrdersMenu,
      },
      {
        label: "રિસીવ",
        href: route.cuttingReceives,
        listKey: "cuttingReceives",
        permission: permission.cuttingReceivesMenu,
      },
    ],
  },
  {
    title: "ટર્નિંગ",
    description: "ટર્નિંગ ઓર્ડર અને રિસીવ મેનેજ કરો",
    href: route.turningOrders,
    listKey: "turningOrders",
    icon: "⚙️",
    permission: permission.turningOrdersMenu,
    actions: [
      {
        label: "ઓર્ડર",
        href: route.turningOrders,
        listKey: "turningOrders",
        permission: permission.turningOrdersMenu,
      },
      {
        label: "રિસીવ",
        href: route.turningReceives,
        listKey: "turningReceives",
        permission: permission.turningReceivesMenu,
      },
    ],
  },
  {
    title: "VMC",
    description: "VMC ઓર્ડર અને રિસીવ મેનેજ કરો",
    href: route.vmcOrders,
    listKey: "vmcOrders",
    icon: "🛠️",
    permission: permission.vmcOrdersMenu,
    actions: [
      {
        label: "ઓર્ડર",
        href: route.vmcOrders,
        listKey: "vmcOrders",
        permission: permission.vmcOrdersMenu,
      },
      {
        label: "રિસીવ",
        href: route.vmcReceives,
        listKey: "vmcReceives",
        permission: permission.vmcReceivesMenu,
      },
    ],
  },
  {
    title: "Employees",
    description: "કામદાર અને પગારનું સંચાલન કરો",
    href: route.employees,
    listKey: "employees",
    icon: "👷",
    permission: permission.employeesMenu,
  },
];

export const masterModules: AppModuleProps[] = [
  {
    title: "Items",
    description: "આઈટમ્સનું સંચાલન કરો",
    href: route.items,
    listKey: "items",
    icon: "📦",
    permission: permission.itemsMenu,
    superAdminOnly: false,
  },
  {
    title: "Material",
    description: "મટીરીયલનું સંચાલન કરો",
    href: route.materials,
    listKey: "materials",
    icon: "🧱",
    permission: permission.materialsMenu,
    superAdminOnly: false,
  },
  {
    title: "Category",
    description: "કેટેગરી અને કોડનું સંચાલન કરો",
    href: route.categories,
    listKey: "categories",
    icon: "🗂️",
    permission: permission.categoriesMenu,
    superAdminOnly: false,
  },
  {
    title: "Parties",
    description: "પાર્ટીઝ અને ગ્રાહકોનું સંચાલન કરો",
    href: route.parties,
    listKey: "parties",
    icon: "👥",
    permission: permission.partiesMenu,
    superAdminOnly: false,
  },
  {
    title: "Daybook",
    description: "રોજમેળનું સંચાલન કરો",
    href: route.accounts,
    listKey: "accounts",
    icon: "📓",
    permission: permission.accountsMenu,
    superAdminOnly: false,
  },
  {
    title: "Users",
    description: "યુઝર્સ અને રોલનું સંચાલન કરો",
    href: route.users,
    listKey: "users",
    icon: "👤",
    permission: permission.usersMenu,
    superAdminOnly: true,
  },
];

export const appModules: AppModuleProps[] = [
  ...dailyUsageModules,
  ...masterModules,
];

export const visibleActions = (
  appModule: AppModuleProps,
  permissions: string[] | undefined
): AppModuleActionProps[] =>
  (appModule.actions || []).filter((action) =>
    hasPermission(permissions, action.permission)
  );

export const getVisibleModules = (
  modules: AppModuleProps[],
  permissions: string[] | undefined,
  isSuperAdmin: boolean = false
): AppModuleProps[] =>
  modules.filter(
    (appModule) =>
      (!appModule.superAdminOnly || isSuperAdmin) &&
      (appModule.actions
        ? visibleActions(appModule, permissions).length > 0
        : hasPermission(permissions, appModule.permission))
  );
